
// import SignUpRegistration from "@/components/SignUpRegistration.vue";
import { defineComponent } from "vue";
import NavigationList from "@/components/NavigationList.vue";
export default defineComponent({
  components: { NavigationList },
});
